import React from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { Link } from 'react-router-dom';
import MobileNavigation from './MobileNavigation';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter, faFacebookF, faYoutube, faInstagram } from "@fortawesome/free-brands-svg-icons"
import dp from '../assets/dp.jpg'
// import './layout.css'

const SocialLinks = {
    instagram: 'https://instagram.com/aura.djsce?igshid=wb2v3l0549dd',
    youtube: 'https://www.youtube.com/channel/UC_Cy6EmraiY5nV1Xyv2tPPw',
    twitter: 'https://twitter.com/aura_djsce',
    facebook: 'https://www.facebook.com/aura.djs/'
  };

  const handleSocialLinks = network => () => {
    window.open(SocialLinks[network]);
  };

  const socialIconStyle = {
    width: 30,
    height: 30,
    marginRight: 10,
    cursor: 'pointer'
};

function Header(props) {
    // const [head, sethead] = React.useState('');

    const sendType=()=>{
        props.getType('streetplay')
    }

    return (
        <div className="outerHeader" >
            <nav id="navigation"
                className="center sticky-top"
                style={
                    { top: 0 }} >
                <Hidden only={
                    ['xs', 'sm']} >
                    <Grid container spacing={0} >
                        <Grid item md={2} >
                            <Link to='/'
                                id="hover" >
                                <h1 id="logo">
                            <span><img src = {dp} className='loadingTemp' alt='load'/></span>
                                    AURA
                            <sub style={{ verticalAlign: 'sub', fontSize: '0.7rem', marginLeft: '-30px' }}> Kayam Rahe
                            </sub>
                                </h1>
                            </Link>
                        </Grid>

                        <Grid item md={6}>
                            <ul id="navigation-menu" >
                                <li className="navigation-link active" >
                                    <Link to='/work'
                                        id="hover" onClick={sendType}>
                                        Our Work </Link>
                                </li>

                                <li className="navigation-link active" >
                                    <Link to='/blogs' id="hover" >
                                    Writer’s Niche  </Link>
                                </li>
                                <li className="navigation-link active" >
                                    <Link to='/auditions-2022' id="hover" >
                                   Auditions </Link>
                                </li>
                            </ul>
                        </Grid>
                        <Grid item md={4} >
                            <FontAwesomeIcon className="icon"
                            onClick={handleSocialLinks('twitter')} id="social-link"
                            style ={socialIconStyle}
                                icon={faTwitter}
                            /> 
                            <   FontAwesomeIcon className="icon"
                            onClick={handleSocialLinks('youtube')} id="social-link"
                            style ={socialIconStyle}
                                icon={faYoutube}
                            /> 
                            <FontAwesomeIcon className="icon"
                            onClick={handleSocialLinks('instagram')} id="social-link"
                            style ={socialIconStyle}
                                icon={faInstagram}
                            /> 
                            <FontAwesomeIcon className="icon"
                            onClick={handleSocialLinks('facebook')} id="social-link"
                            style ={socialIconStyle}
                                icon={faFacebookF}
                            /> 
                        </Grid>
                    </Grid> </Hidden>

                <Hidden only={['md', 'lg', 'xl']} >
                    <Link to='/'
                        id="hover" >
                        <h1 id="logo"
                            className="align-center" >
                                <span><img src = {dp} className='loadingTemp' alt='load'/></span>
                            AURA
                             <sub style={{ verticalAlign: 'sub', fontSize: '0.7rem', marginLeft: '-30px' }} > Kayam Rahe
                                                                                    </sub>
                        </h1>
                    </Link> <MobileNavigation prop={sendType} /> </Hidden>
            </nav>
        </div>
    );
}


export default Header;